import Request from '@/classes/Api/Request';

class Client {
  constructor(request) {
    this.request = request;
  }

  signIn(email, password) {
    return this.request.post('/api/v1/auth/login', {
      email: email,
      password: password,
    });
  }

  signUp(name, lastName, email, phone, providerCode) {
    return this.request.post('/api/v1/auth/register', {
      name: name,
      email: email,
      phone: phone,
      last_name: lastName,
      provider_code: providerCode,
    });
  }

  logout() {
    return this.request.post('/api/v1/auth/logout');
  }

  refreshToken() {
    return this.request.post('/api/v1/auth/refresh');
  }

  getProfile() {
    return this.request.get('/api/v1/user/profile');
  }

  getMeasures() {
    return this.request.get('/api/v1/lists/measures');
  }

  getLifeSituations() {
    return this.request.get('/api/v1/lists/life_situations');
  }

  getLifeEvents(lifeSituationId) {
    return this.request.get('/api/v1/lists/life_events', {
      life_situation_id: lifeSituationId,
    });
  }

  getLevels() {
    return this.request.get('/api/v1/lists/levels');
  }

  getConditions(lifeSituationId) {
    return this.request.get('/api/v1/lists/conditions', {
      life_situation_id: lifeSituationId,
    });
  }

  getConditionList(filter) {
    return this.request.get('/api/v1/conditions/list', filter);
  }

  getConditionListFilter(filter) {
    return this.request.get('/api/v1/conditions/filter', filter);
  }

  getConditionCategories() {
    return this.request.get('/api/v1/lists/condition_categories');
  }

  getDictionaryReqStatuses() {
    return this.request.get('/api/v1/lists/dictionary_req_statuses');
  }

  getLMSPReqStatuses() {
    return this.request.get('/api/v1/lists/lmsp_req_statuses');
  }

  searchConditions(query, categoryId) {
    return this.request.get('/api/v1/search/condition', {
      name: query,
      category_id: categoryId,
    });
  }

  getMeasureRelations(id) {
    return this.request.get(`/api/v1/measures/${id}/relations`);
  }

  getLMSPInfo(uid) {
    return this.request.get('/api/v1/lmsp/info', {
      uuid: uid,
    });
  }

  findDataProvider(code) {
    return this.request.get('/api/v1/dataprovider/info', {
      provider_code: code,
    });
  }

  getLMSPFilter(filter) {
    return this.request.get('/api/v1/lmsp/filter', filter);
  }

  saveFederalMSP(fields) {
    return this.request.post('/api/v1/federal_msp', fields);
  }

  saveDictionaryRequest(fields) {
    return this.request.post('/api/v1/dictionary_request', fields);
  }

  getOperatorDictionaryRequestList(filter) {
    return this.request.get('/api/v1/operator/dictionary_requests', filter);
  }

  getOperatorDictionaryRequestFilter(filter) {
    return this.request.get(
      '/api/v1/operator/dictionary_requests/filter',
      filter
    );
  }

  getOperatorDictionaryRequest(id) {
    return this.request.get(`/api/v1/operator/dictionary_request/${id}`);
  }

  updateOperatorDictionaryRequest(id, fields) {
    return this.request.put(
      `/api/v1/operator/dictionary_request/${id}`,
      fields
    );
  }

  getSourceComments(sourceId) {
    return this.request.get(
      `/api/v1/source/${sourceId}/comments`
    );
  }

  createOperatorDictionaryReqComment(sourceId, text) {
    return this.request.post(
      `/api/v1/operator/dictionary_request/${sourceId}/comment`,
      {text}
    );
  }

  createHeadLMSPReqComment(sourceId, text) {
    return this.request.post(
      `/api/v1/system/lmsp/requests/${sourceId}/comment`,
      {text}
    );
  }

  getDictionaryRequestList(page) {
    return this.request.get('/api/v1/dictionary_request', {
      page: +page,
    });
  }

  saveLMSPRequest(fields) {
    return this.request.post('/api/v1/lmsp/requests', fields);
  }

  updateLMSPRequest(id, fields) {
    return this.request.put(`/api/v1/lmsp/requests/${id}`, fields);
  }

  getLMSPRequestList(filter) {
    return this.request.get('/api/v1/lmsp/requests', filter);
  }

  getHeadLMSPRequestList(filter) {
    return this.request.get('/api/v1/head/lmsp/requests', filter);
  }

  getOperatorLMSPRequestList(filter) {
    return this.request.get('/api/v1/operator/lmsp/requests', filter);
  }

  updateOperatorLMSPRequest(id, fields) {
    return this.request.put(`/api/v1/system/lmsp/requests/${id}`, fields);
  }

  getLMSPRequest(id) {
    return this.request.get(`/api/v1/lmsp/requests/${id}`);
  }

  startExport() {
    return this.request.get(`/api/v1/lmsp/export`);
  }

  checkExport(id) {
    return this.request.get(`/api/v1/lmsp/export/check/${id}`);
  }

  getDownloadExportUrl(id) {
    return this.request.buildPath(`/api/v1/lmsp/export/download/${id}`);
  }

  getDownloadManualUrl() {
    return this.request.buildPath('/api/v1/docs/manual');
  }
}

const client = new Client(Request);

export default client;
